// extracted by mini-css-extract-plugin
export var caretAnchor = "_vh-0";
export var dropdownContent = "_vh-1";